module.exports = __webpack_public_path__ + "img/south-korea.793c8ae2.svg";